import { SelectOptions } from "@/component/input";
import { TaskTemplateReference } from "./ITaskTemplates";

export type DayTime = "" | "morning" | "lunch" | "evening" | "night";

export type Frequency = "" | "daily" | "weekly" | "biweekly" | "monthly";

export type TaskStatus =
  "" | "pending" | "completed" | "overdue" | "skipped" | "not needed";

export enum IDEAL_TIME {
  ANYTIME = "anytime",

  SESSION = "session",

  SPECIFIC_TIME = "specific-time",
}

export type TaskManagement = {
  selectedUsers: SelectOptions[];
  selectedCategory: SelectOptions | null;
  selectedTasks: SelectOptions[];
  startDate: Date;
  startTime: string;
  description: string;
  idealTime: IDEAL_TIME;
  dayTime: DayTime[];
  recurring: boolean;
  rrule: {
    frequency?: Frequency;
    interval?: "day" | "week";
    intervalCount?: number;
  };
  noteSubmitRequired: boolean;
  showInRoster?: boolean;
};

export interface Category {
  _id: string;
  title: string;
  logo: string;
}

export interface User {
  _id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name?: string;
  avatar?: string;
  landlineNumber?: string;
  mobileNumber?: string;
  phoneNumber?: string;
}

export interface TaskManagementResponse {
  _id: string;
  tasks: Category[];
  serviceUser: User | null;
  startDate: Date;
  startTime: string;
  idealTime: IDEAL_TIME;
  dayTime: DayTime[];
  recurring: boolean;
  description: string;
  status?: Record<string, TaskStatus>;
  completedBy?: User;
  createdBy?: User;
  noteSubmitRequired: boolean;
  showInRoster?: boolean;
  rrule: TaskManagement["rrule"];
  category: Category;
  template?: TaskTemplateReference;
  __v: number;
  createdAt: Date;
  updatedAt: Date;
}

export type TaskManagementFilters = {
  page?: number;
  limit?: number;
  search?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  serviceUser?: string[];
  category?: string[];
  frequency?: string[];
  tasks?: string[];
  status?: string[];
};
